/* eslint-disable import/prefer-default-export */
export function getEnv<T>(defaults: T): T {
  const { env } = (window as unknown) as {
    env?: T
  }

  // console.log('getEnv()', env, defaults);
  if (env !== undefined) {
    const returnEnv = {
      ...defaults,
      ...env,
    }
    // console.log('getEnv() -> ', returnEnv);
    return returnEnv
  }
  return defaults
}

type TAccallioLibInfo = {
  libVersion: string
  appVersion: string
}

export const accallioLibInfo: TAccallioLibInfo = {
  libVersion: LIB_VERSION,
  appVersion: APP_VERSION,
}
